// extracted by mini-css-extract-plugin
export default {"modalArea":"MegaMenu_modalArea__0E69M","modalArea__loader":"MegaMenu_modalArea__loader__QPtuD","modalArea__services":"MegaMenu_modalArea__services__9sPpG"};